import { Transition, TransitionRootProps } from '@headlessui/react';
import { clstx } from '@payaca/utilities/cvaMerge';
import { ElementType, PropsWithChildren } from 'react';

type TransitionProps<TTag extends ElementType = 'div'> = Omit<
  TransitionRootProps<TTag>,
  'enter' | 'enterFrom' | 'enterTo' | 'leave' | 'leaveFrom' | 'leaveTo'
>;

const AppearTransition = <TTag extends ElementType = 'div'>(
  props: PropsWithChildren<TransitionProps<TTag>>
) => {
  const {
    as = 'div' as TTag,
    appear = true,
    children,
    // @ts-expect-error: `className` is not part of TransitionRootProps, however it actually is...
    className,
    ...rest
  } = props;

  return (
    <Transition
      as={as}
      appear={appear}
      className={clstx(
        // shared transition classes
        'data-[transition]:transition data-[transition]:duration-300 opacity-100 translate-x-0',
        // closed state classes
        'data-[closed]:opacity-0 data-[closed]:-translate-x-full',
        className
      )}
      {...rest}
    >
      {children}
    </Transition>
  );
};

export default AppearTransition;
